// @generated by protoc-gen-connect-es v1.1.3 with parameter "target=js+dts"
// @generated from file public_api/portfolio/v1/private_benchmark.proto (package public_api.portfolio.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetPrivateFundBenchmarksRequest, GetPrivateFundBenchmarksResponse, GetPrivatePortfolioBenchmarksRequest, GetPrivatePortfolioBenchmarksResponse, SetPrivateFundBenchmarksRequest, SetPrivateFundBenchmarksResponse, SetPrivatePortfolioBenchmarksRequest, SetPrivatePortfolioBenchmarksResponse } from "./private_benchmark_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service public_api.portfolio.v1.BenchmarkService
 */
export const BenchmarkService = {
  typeName: "public_api.portfolio.v1.BenchmarkService",
  methods: {
    /**
     * @generated from rpc public_api.portfolio.v1.BenchmarkService.GetPrivateFundBenchmarks
     */
    getPrivateFundBenchmarks: {
      name: "GetPrivateFundBenchmarks",
      I: GetPrivateFundBenchmarksRequest,
      O: GetPrivateFundBenchmarksResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc public_api.portfolio.v1.BenchmarkService.GetPrivatePortfolioBenchmarks
     */
    getPrivatePortfolioBenchmarks: {
      name: "GetPrivatePortfolioBenchmarks",
      I: GetPrivatePortfolioBenchmarksRequest,
      O: GetPrivatePortfolioBenchmarksResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc public_api.portfolio.v1.BenchmarkService.SetPrivateFundBenchmarks
     */
    setPrivateFundBenchmarks: {
      name: "SetPrivateFundBenchmarks",
      I: SetPrivateFundBenchmarksRequest,
      O: SetPrivateFundBenchmarksResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc public_api.portfolio.v1.BenchmarkService.SetPrivatePortfolioBenchmarks
     */
    setPrivatePortfolioBenchmarks: {
      name: "SetPrivatePortfolioBenchmarks",
      I: SetPrivatePortfolioBenchmarksRequest,
      O: SetPrivatePortfolioBenchmarksResponse,
      kind: MethodKind.Unary,
    },
  }
};

